class InputCtaWrapper extends HTMLElement {
  connectedCallback() {
    this.input = /** @type {HTMLInputElement} */ (this.querySelector('.wrapper-input'));
    this.button = /** @type {HTMLButtonElement} */ (this.querySelector('.wrapper-cta'));

    if (!this.input || !this.button) return;

    this.input.addEventListener('input', this.#updateButton);
    window.addEventListener('pageshow', this.#updateButton);

    if (this.hasAttribute('clear-on-click')) {
      this.button.addEventListener('click', this.clearInput);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('pageshow', this.#updateButton);
    if (this.button) {
      this.button.removeEventListener('click', this.clearInput);
    }
  }

  #updateButton = () => {
    if (!this.input || !this.button) return;

    this.button.disabled = this.input.value === '';
  };

  clearInput = () => {
    if (this.input) {
      this.input.value = '';
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  };
}

if (!customElements.get('input-cta-wrapper')) {
  customElements.define('input-cta-wrapper', InputCtaWrapper);
}
